import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79789bc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "brand"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = {
  key: 2,
  id: "title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.isAdmin ? "/artists-list" : "/profil"
  }, {
    default: _withCtx(() => [
      (!_ctx.$props.isCenter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      (!_ctx.store.state.isMobile && _ctx.store.state.title == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.$props.isCenter? "brand-large" : "brand-small" )
            }, [
              _createTextVNode("artspedia"),
              _hoisted_3,
              _createTextVNode("dashboard")
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.store.state.title != null)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.store.state.title), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to"]))
}